// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateIndexingEngineSelectionOptionOverrideMutationVariables =
  Types.Exact<{
    databaseId: Types.Scalars["ID"]["input"];
    tableId: Types.Scalars["ID"]["input"];
    settings?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
    preset?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
    useConsolidation?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  }>;

export type UpdateIndexingEngineSelectionOptionOverrideMutation = {
  __typename?: "Mutation";
  updateIndexingEngineSelectionOptionOverride?: {
    __typename?: "IndexAdvisorConfigForTable";
    id: string;
    settings?: any | null;
    settingsName: string;
    defaultPreset?: string | null;
    lastRunAt?: number | null;
  } | null;
};

export const UpdateIndexingEngineSelectionOptionOverrideDocument = gql`
  mutation UpdateIndexingEngineSelectionOptionOverride(
    $databaseId: ID!
    $tableId: ID!
    $settings: String
    $preset: String
    $useConsolidation: Boolean
  ) {
    updateIndexingEngineSelectionOptionOverride(
      databaseId: $databaseId
      tableId: $tableId
      settings: $settings
      preset: $preset
      useConsolidation: $useConsolidation
    ) {
      id
      settings
      settingsName
      defaultPreset
      lastRunAt
    }
  }
`;
export type UpdateIndexingEngineSelectionOptionOverrideMutationFn =
  Apollo.MutationFunction<
    UpdateIndexingEngineSelectionOptionOverrideMutation,
    UpdateIndexingEngineSelectionOptionOverrideMutationVariables
  >;

/**
 * __useUpdateIndexingEngineSelectionOptionOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateIndexingEngineSelectionOptionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndexingEngineSelectionOptionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndexingEngineSelectionOptionOverrideMutation, { data, loading, error }] = useUpdateIndexingEngineSelectionOptionOverrideMutation({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *      settings: // value for 'settings'
 *      preset: // value for 'preset'
 *      useConsolidation: // value for 'useConsolidation'
 *   },
 * });
 */
export function useUpdateIndexingEngineSelectionOptionOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIndexingEngineSelectionOptionOverrideMutation,
    UpdateIndexingEngineSelectionOptionOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateIndexingEngineSelectionOptionOverrideMutation,
    UpdateIndexingEngineSelectionOptionOverrideMutationVariables
  >(UpdateIndexingEngineSelectionOptionOverrideDocument, options);
}
export type UpdateIndexingEngineSelectionOptionOverrideMutationHookResult =
  ReturnType<typeof useUpdateIndexingEngineSelectionOptionOverrideMutation>;
export type UpdateIndexingEngineSelectionOptionOverrideMutationResult =
  Apollo.MutationResult<UpdateIndexingEngineSelectionOptionOverrideMutation>;
export type UpdateIndexingEngineSelectionOptionOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateIndexingEngineSelectionOptionOverrideMutation,
    UpdateIndexingEngineSelectionOptionOverrideMutationVariables
  >;
